module.exports = [{
      plugin: require('/var/lib/jenkins/workspace/fox.uikit/fox.uikit.deploy.prod/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
